module.exports = __webpack_public_path__ + "static/media/SB800.7b76636d.png";